import Model from './Model';
import Collection from './Collection';

export class Keyword extends Model {

	defaults() {
		return {
			id: null,
			keywordListId: null,
			projectId: null,
			keyword: null,
		};
	}

	routes() {
		return {
			create: 'keywords',
			patch: 'keywords/{id}',
			delete: 'keywords/{id}',
		};
	}

	options() {
		return {
			patch: true,
		};
	}

}

export class Keywords extends Collection {

	model() {
		return Keyword;
	}

	routes() {
		return {
			fetch: 'keywords?keywordListId={id}',
		};
	}

}

export class KeywordList extends Model {

	defaults() {
		return {
			id: null,
			projectId: null,
			name: '',
			isDefault: false,
			wholeWordsOnly: false,
			caseSensitive: false,
		};
	}

	mutations() {
		return {
			id: id => Number(id) || null,
			projectId: id => Number(id) || null,
			name: String,
			isDefault: Boolean,
			wholeWordsOnly: Boolean,
			caseSensitive: Boolean,
		};
	}

	routes() {
		return {
			create: '/keyword-lists',
			fetch: '/keyword-lists/{id}',
			patch: '/keyword-lists/{id}',
			delete: '/keyword-lists/{id}',
		};
	}

	options() {
		return {
			patch: true,
		};
	}

}

export class KeywordListDefault extends Model {

	defaults() {
		return {
			id: null,
		};
	}

	routes() {
		return {
			save: '/keyword-lists/{id}/default',
		};
	}

}

export class KeywordLists extends Collection {

	model() {
		return KeywordList;
	}

	routes() {
		return {
			fetch: '/keyword-lists?projectId={id}',
		};
	}

}
